import * as I from 'immutable';
import {ToPartialMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

export type trustee = {
    "firstName" : string,
    "lastName": string
}

const EmptyTrustee: trustee = {
  "firstName" : '',
  "lastName"  : '',
}

export class UnvalidatedHippaTrustees {
  public readonly key = 'UnvalidatedHippaTrustees';

  constructor(
    public readonly trustees: I.List<trustee>
  ) {}
}

export class InvalidHippaTrustees {
  public readonly key = 'InvalidHippaTrustees';

  constructor(
    public readonly trustees: I.List<trustee>
  ) {}
}

type AppProps = {
    trustees: I.List<trustee>;
};

export class ValidHippaTrustees {
  public static createFromApp({
    trustees,
  }: AppProps) {
    return this.create(
        trustees
    );
  }

  public static create(
    trustees: I.List<trustee>
  ) {
    return trustees.size > 0
      ? new ValidHippaTrustees(
        trustees
        )
      : new InvalidHippaTrustees(
        trustees
        );
  }

  public readonly key = 'ValidHippaTrustees';
  private constructor(
    public readonly trustees: I.List<trustee>
  ) {}
}

export type HippaTrustees = UnvalidatedHippaTrustees | InvalidHippaTrustees | ValidHippaTrustees;

export type HippaTrusteesOptions<TReturn> = ToPartialMatchOptions<HippaTrustees, 'key', TReturn>;

export const matchHippaTrustees = <TReturn>(options: HippaTrusteesOptions<TReturn>) => (app: HippaTrustees): TReturn => {
  switch (app.key) {
    case 'InvalidHippaTrustees':
      return options.InvalidHippaTrustees ? options.InvalidHippaTrustees(app) : options.default(app);
    case 'UnvalidatedHippaTrustees':
      return options.UnvalidatedHippaTrustees ? options.UnvalidatedHippaTrustees(app) : options.default(app);
    case 'ValidHippaTrustees':
      return options.ValidHippaTrustees ? options.ValidHippaTrustees(app) : options.default(app);
  }
};


export const addTrustee = () => (app: HippaTrustees) => {
  const newList = app.trustees.push(EmptyTrustee);
  return ValidHippaTrustees.create(newList);
}

export const changeFirstName = (firstName: string, index : number) => (app: HippaTrustees) => {
    const existingTrustee: trustee = app.trustees.get(index) as trustee;
    const hippaTrustee: trustee = {
      'firstName' : firstName,
      'lastName' : existingTrustee.lastName,
    }
    const newList = app.trustees.set(index, hippaTrustee);
    return ValidHippaTrustees.create(newList);
}

export const changeLastName = (lastName: string, index : number) => (app: HippaTrustees) => {
    const existingTrustee: trustee = app.trustees.get(index) as trustee;
    const hippaTrustee: trustee = {
      'firstName' : existingTrustee.firstName,
      'lastName' : lastName,
    }
    const newList = app.trustees.set(index, hippaTrustee);
    return ValidHippaTrustees.create(newList);
}

export const deleteTrustee = (index : number) => (app: HippaTrustees) => {
  const newList = app.trustees.delete(index);
  return ValidHippaTrustees.create(newList);
}
 
export const EmptyHippaTrustees = new UnvalidatedHippaTrustees(
    I.List<trustee>().set(0, EmptyTrustee)
);



